import { useState, useEffect, useCallback } from 'react';
import config from '../config';

export function EstadoPagoGTModalAgregar({ dataLogin, indicadorUF, indicadorUFPasado, obtenerDiasEnMes, UFmensual, UFmensualPasado, diasFestivos, navigate, onClose, Select, today }) {
  const [clientes, setClientes] = useState([]);
  const [serviciosSeleccionados, setServiciosSeleccionados] = useState([]);
  const [UFFacturacion, setUFFacturacion] = useState(null);
  const [diasFacturar, setDiasFacturar] = useState(null);
  const [diasMes, setDiasMes] = useState(30);
  const idExtrasGrua = [88, 207, 225];
  const idExtrasOp = [206, 227, 228, 256];
  const idExtrasOpDF = [205];
  const [usarTarifa, setUsarTarifa] = useState(false);

  useEffect(() => {
    obtenerClientes();
  }, []);

  const obtenerClientes = async () => {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/cliente.php`
      );
      const data = await response.json();

      if (data && data[0].id_cliente) {
        setClientes(data);
      }
    } catch (error) {
      setClientes([]);
    }
  };

  const [servicios, setServicios] = useState([]);
  const obtenerServicios = async (folio) => {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/servicio.php?folio=${folio}`
      );
      const data = await response.json();

      if (data && data[0].id_servicio) {
        setServicios(data)
      }
    } catch (error) {
      setServicios([]);
    }
  };

  const [clienteSelected, setClienteSelected] = useState('');
  const handleClienteSelect = async (clienteSelected) => {
    setClienteSelected(clienteSelected.value);
    await obtenerClienteObra(clienteSelected.value);

    setEstadoPagoData({
      ...dataEstadoPago,
      ["id_cliente_ep"]: clienteSelected.value,
      ["id_cliente_final_ep"]: clienteSelected.value,
      ["id_usuario"]: dataLogin.id_usuario
    });
  };

  const optionsClientes = clientes.map((cliente) => ({
    value: cliente.id_cliente,
    label: cliente.nombre_cliente,
  }));

  const handleObraSelect = async (obraSelected) => {
    await obtenerFolios(obraSelected);

    setDataConsultaReports({
      ...dataConsultaReports,
      ["id_obra_ep"]: obraSelected,
    });

    setEstadoPagoData({
      ...dataEstadoPago,
      ["id_obra_ep"]: obraSelected,
    });
  };

  const [clienteObra, setclienteObra] = useState([]);
  const obtenerClienteObra = async (cliente) => {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/cliente_obra.php?id_cliente=${cliente}`
      );
      const data = await response.json();

      if (data && data[0].id_obra) {
        setclienteObra(data);
      }
    } catch (error) {
      setclienteObra([]);
    }
  };

  const [folios, setFolios] = useState([]);
  const obtenerFolios = async (obra) => {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/cabecera_cotizacion.php?id_obra=${obra}&id_maquinaria=3`
      );
      const data = await response.json();

      if (data && data[0].folio) {
        setFolios(data);
      }
    } catch (error) {
      setFolios([]);
    }
  };

  const [dataDetalleOperador, setDataDetalleOperador] = useState({
    horas_incluidas_operador: 0,
    valor_hora_adicional_uf: 0,
    valor_hora_adicional_sabados_uf: 0,
    valor_hora_adicional_domingos_festivos_uf: 0,
    valor_uf_fecha_facturacion: indicadorUF
  });

  const [dataDetalleGrua, setDataDetalleGrua] = useState({
    horas_incluidas_grua: 0,
    valor_hora_adicional_uf: 0,
    valor_uf_fecha_facturacion: indicadorUF
  });

  const [dataEstadoPago, setEstadoPagoData] = useState({
    folio_ep: "",
    id_obra_ep: "",
    id_cliente_ep: "",
    id_cliente_final_ep: "",
    horas_trabajadas_cantidad: "",
    horas_incluidas_operador: "",
    horas_adicionales_operador: "",
    valor_hora_adicional_uf_operador: "",
    horas_adicionales_domingos_festivos_operador: "",
    valor_hora_adicional_domingos_festivos_uf_operador: "",
    horas_adicionales_sabados: "",
    valor_hora_adicional_sabados_uf: "",
    valor_total_horas_adicionales_operador: "",
    horas_incluidas_grua: "",
    horas_adicionales_grua: "",
    valor_hora_adicional_uf_grua: "",
    valor_total_horas_adicionales_grua: "",
    valor_uf_fecha_facturacion: "",
    otros_descuentos_ep: 0,
    detalle_otros_descuentos_ep: "",
    total_neto: "",
    iva: "",
    total: "",
    id_usuario: ""
  });

  const handleFormEstadoPagoData = (e) => {
    const { name, value } = e.target;
    setEstadoPagoData({
      ...dataEstadoPago,
      [name]: value,
    });

    setDataConsultaReports({
      ...dataConsultaReports,
      [name]: value,
    });

    obtenerServicios(e.target.value)
  };

  const [dataConsultaReports, setDataConsultaReports] = useState({
    id_obra_ep: "",
    folio_ep: "",
    fecha_desde_ep: "",
    fecha_hasta_ep: ""
  });

  const [dataReports, setDataReports] = useState([]);

  const [dataServiciosFolio, setDataServiciosFolio] = useState([]);

  const [valorServicios, setValorServicios] = useState(0);

  const [dataTotalesGrua, setDataTotalesGrua] = useState({
    horas_trabajadas_cantidad: 0,
    horas_facturar_grua: 0,
    dias_facturar_grua: 0,
    dias_del_mes: 0,
    horas_incluidas_grua: 0,
    horas_adicionales: 0,
    valor_hora_adicional_uf: 0,
    valor_uf_fecha_facturacion: 0,
    valor_total_horas_adicionales: 0
  });

  // Esta función será pasada al hijo para que lo actualice
  const handleValorServiciosChange = useCallback((valor) => {
    setValorServicios(valor);
  }, []);

  const handleSubmitBuscarReports = async (event) => {
    event.preventDefault();
    try {
      const esFormularioValido = validaFormularioBuscarReports();

      if (esFormularioValido) {
        setDataReportsGT({});
        setCheckboxStatesRepGT({});
        setSelectAll(false);

        const idObra = dataConsultaReports.id_obra_ep;
        const folio = dataConsultaReports.folio_ep;
        const fechaDesde = dataConsultaReports.fecha_desde_ep;
        const fechaHasta = dataConsultaReports.fecha_hasta_ep;

        // Obtiene otros servicios asociados al folio
        const responseServicios = await fetch(
          `${config.apiBaseUrl}/estado_pago_gt.php?folio=${folio}`
        );

        const dataServicios = await responseServicios.json();

        if (dataServicios && dataServicios[0].folio) {
          const newData = dataServicios.map(item => {
            const valorUnitario = parseFloat(item.valor_unitario_neto);
            const valorMaximo = parseFloat(item.valor_unitario_neto * 1);//1.8
            const valorTotal = Math.round(valorUnitario * UFFacturacion);

            return {
              ...item,
              valor_total: valorTotal,
              valor_maximo: valorMaximo,
              valor_normal: valorUnitario,   // ✅ GUARDAR EL VALOR UF ORIGINAL
            };
          });
          // 👇 espera 500ms antes de actualizar el estado
          setTimeout(() => {
            setDataServiciosFolio(newData);
          }, 500);
        } else {
          setTimeout(() => {
            setDataServiciosFolio([]);
          }, 500);
        }

        const response = await fetch(
          `${config.apiBaseUrl}/estado_pago_gt.php?id_obra=${idObra}&folio=${folio}&fecha_desde=${fechaDesde}&fecha_hasta=${fechaHasta}`
        );
        const data = await response.json();

        // Cálculo de valores con fecha del último día de arriendo
        const [year, month, day] = fechaHasta.split('-');
        const fechaUltimoDiaEP = `${day}-${month}-${year}`;

        setDiasMes(obtenerDiasEnMes(month, year));
        setDiasFacturar(obtenerDiasEnMes(month, year));

        // Helper para buscar en una serie por la fecha dd-mm-yyyy
        const buscarEnSeriePorDDMMYYYY = (data, fechaDDMMYYYY) => {
          if (!data || !data.serie || !Array.isArray(data.serie)) return null;
          return data.serie.find(item => {
            const itemDate = new Date(item.fecha).toLocaleDateString('es-CL');
            return itemDate === fechaDDMMYYYY;
          }) || null;
        };

        // Buscar primero en el año actual y si no está, en el pasado
        const encontradoActual = buscarEnSeriePorDDMMYYYY(UFmensual, fechaUltimoDiaEP);
        const encontradoPasado = buscarEnSeriePorDDMMYYYY(UFmensualPasado, fechaUltimoDiaEP);
        const fechaActualIndicadorUF = encontradoActual || encontradoPasado || null;

        // Obtener valor seguro y fallback a indicadorUF si es necesario
        const valorUF = Number(fechaActualIndicadorUF?.valor);
        const valorFechaUF = (fechaActualIndicadorUF && !isNaN(valorUF) && valorUF !== 0)
          ? valorUF
          : (typeof indicadorUF === 'number' && !isNaN(indicadorUF) ? indicadorUF : 0);

        setUFFacturacion(valorFechaUF);
        

        if (data && data[0].id_report_gt) {

          //FIX EEPP JULIO - MG - GT2 setDiasFacturar(data[0].dias_facturar_mes)
          setDiasFacturar(data[0].dias_facturar_mes);

          const resultadoFormateado = data.map(item => {
            //Obtener día y mes report
            const partesFecha = item.fecha_report.split('-');
            const date = new Date(`${partesFecha[2]}-${partesFecha[1]}-${partesFecha[0]}`);

            const diasSemana = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
            const nombreMeses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

            const diaSemana = diasSemana[date.getDay()];
            const nombreMes = nombreMeses[date.getMonth()];

            dataDetalleOperador.horas_incluidas_operador = item.horas_incluidas_operador ? item.horas_incluidas_operador : 0;
            dataDetalleOperador.valor_hora_adicional_uf = item.valor_hr_adicional_operador ? Number(item.valor_hr_adicional_operador).toFixed(4) : 0;
            dataDetalleOperador.valor_hora_adicional_sabados_uf = item.valor_hr_adicional_operador_s ? Number(item.valor_hr_adicional_operador_s).toFixed(4) : 0;
            dataDetalleOperador.valor_hora_adicional_domingos_festivos_uf = item.valor_hr_adicional_operador_df ? Number(item.valor_hr_adicional_operador_df).toFixed(4) : 0;
            dataDetalleOperador.valor_uf_fecha_facturacion = valorFechaUF ? valorFechaUF : indicadorUF;

            dataDetalleGrua.horas_incluidas_grua = item.horas_incluidas_grua ? item.horas_incluidas_grua : 0;
            dataDetalleGrua.valor_hora_adicional_uf = item.valor_hr_adicional_grua ?? 0
            dataDetalleGrua.valor_uf_fecha_facturacion = valorFechaUF ? valorFechaUF : indicadorUF
            dataDetalleGrua.horas_facturar_grua = item.horas_facturar_grua ? item.horas_facturar_grua : 0
            dataDetalleGrua.dias_facturar_grua = item.dias_facturar_grua ? item.dias_facturar_grua : item.dias_del_mes
            dataDetalleGrua.dias_del_mes = item.dias_del_mes
            dataDetalleGrua.horas_cobrables_grua = item.horas_cobrables_dia


            return {
              id_report_gt: item.id_report_gt,
              numero: item.numero,
              fecha_report: item.fecha_report,
              dia: diaSemana,
              mes: nombreMes,
              hora_inicio_manana: item.hora_inicio_manana,
              hora_termino_manana: item.hora_termino_manana,
              hora_inicio_tarde: item.hora_inicio_tarde,
              hora_termino_tarde: item.hora_termino_tarde,
              minimo_horas: item.horas_minimas_dia,
              hora_inicio_colacion: item.hora_inicio_colacion,
              hora_termino_colacion: item.hora_termino_colacion,
              horas_manana: item.horas_manana_hhmm,
              horas_tarde: item.horas_tarde_hhmm,
              total_horas_manana: item.horas_manana_hhmm,
              total_horas_tarde: item.horas_tarde_hhmm,
              total_horas_trabajadas: item.total_laboral_dia_hhmm,
              total_laboral_dia: item.total_laboral_dia,
              total_laboral_dia_hhmm: item.total_laboral_dia_hhmm,
              total_adicional_dia: item.total_adicional_dia,
              total_adicional_dia_hhmm: item.total_adicional_dia_hhmm,
              horas_minimas_dia: item.horas_minimas_dia,
              horas_minimas_dia_hhmm: item.horas_minimas_dia_hhmm,
              horas_incluidas_operador: item.horas_incluidas_operador,
              horas_sabado: item.horas_sabado,
              horas_sabado_hhmm: item.horas_sabado_hhmm,
              horas_dyf: item.horas_dyf,
              horas_dyf_hhmm: item.horas_dyf_hhmm,
              horas_facturar_grua: item.horas_facturar_grua,
              horas_cobrables_grua: item.horas_cobrables_dia,
              dias_facturar_grua: item.dias_facturar_grua ? item.dias_facturar_grua : item.dias_del_mes,
              dias_del_mes: item.dias_del_mes,
              valor_hora_adicional_uf: item.valor_hr_adicional_operador,
              valor_hr_adicional_operador_s: item.valor_hr_adicional_operador_s,
              valor_hr_adicional_operador_df: item.valor_hr_adicional_operador_df
            };
          });

          const resultadoFinal = resultadoFormateado.map(item => ({
            id_report_gt: item.id_report_gt,
            numero: item.numero,
            fecha_report: item.fecha_report,
            dia: item.dia,
            mes: item.mes,
            hora_inicio_manana: item.hora_inicio_manana,
            hora_termino_manana: item.hora_termino_manana,
            hora_inicio_tarde: item.hora_inicio_tarde,
            hora_termino_tarde: item.hora_termino_tarde,
            minimo_horas: item.minimo_horas,
            hora_inicio_colacion: item.hora_inicio_colacion,
            hora_termino_colacion: item.hora_termino_colacion,
            horas_manana: item.horas_manana,
            horas_tarde: item.horas_tarde,
            total_horas_manana: item.horas_manana,
            total_horas_tarde: item.horas_tarde,
            total_horas_trabajadas: item.total_horas_trabajadas,
            total_laboral_dia: item.total_laboral_dia,
            total_laboral_dia_hhmm: item.total_laboral_dia_hhmm,
            total_adicional_dia: item.total_adicional_dia,
            total_adicional_dia_hhmm: item.total_adicional_dia_hhmm,
            horas_minimas_dia: item.horas_minimas_dia,
            horas_minimas_dia_hhmm: item.horas_minimas_dia_hhmm,
            horas_incluidas_operador: item.horas_incluidas_operador,
            horas_sabado: item.horas_sabado,
            horas_sabado_hhmm: item.horas_sabado_hhmm,
            horas_dyf: item.horas_dyf,
            horas_dyf_hhmm: item.horas_dyf_hhmm,
            horas_facturar_grua: item.horas_facturar_grua,
            horas_cobrables_grua: item.horas_cobrables_dia,
            dias_facturar_grua: item.dias_facturar_grua ? item.dias_facturar_grua : item.dias_del_mes,
            dias_del_mes: item.dias_del_mes,
            valor_hora_adicional_uf: item.valor_hora_adicional_uf,
            valor_hr_adicional_operador_s: item.valor_hr_adicional_operador_s,
            valor_hr_adicional_operador_df: item.valor_hr_adicional_operador_df
          }));

          setDataReports(resultadoFinal);
          // console.info(dataReports)
        } else {
          setDataReports([])
        }
      }
    } catch (error) {
      alert("No se encontró información para los filtros indicados.");
    }
  }

  const [dataTotalesOperador, setDataTotalesOperador] = useState({
    horas_trabajadas_cantidad: 0,
    horas_incluidas_operador: 0,
    horas_adicionales: 0,
    valor_hora_adicional_uf: 0,
    horas_adicionales_domingos_festivos: 0,
    valor_hora_adicional_domingos_festivos_uf: 0,
    valor_uf_fecha_facturacion: 0,
    valor_total_horas_adicionales: 0,
    horas_adicionales_sabados: 0,
    valor_hora_adicional_sabados_uf: 0
  });

  const [dataReportsGT, setDataReportsGT] = useState({});
  const [selectAll, setSelectAll] = useState(false)
  const [checkboxStatesRepGT, setCheckboxStatesRepGT] = useState({});// Para los checkboxes legacy

  const toggleCheckboxRepGT = (index, isChecked, report, event) => {
    // console.info(report)
    if (!event?.target?.dataset || event.target.dataset.legacy !== "true") return
    setCheckboxStatesRepGT(prevState => {
      const newState = {
        ...prevState,
        [index]: !prevState[index]
      };

      setDataReportsGT(prevData => {
        const updatedData = { ...prevData };
        if (isChecked) {
          // Si el checkbox está marcado, actualizar los datos como de costumbre
          updatedData[report.id_report_gt] = {
            ...updatedData[report.id_report_gt],
            ["id_report_gt"]: report.id_report_gt,
            ["fecha_report"]: report.fecha_report,
            ["hora_inicio_manana"]: report.hora_inicio_manana,
            ["hora_termino_manana"]: report.hora_termino_manana,
            ["total_horas_manana"]: report.total_horas_manana,
            ["hora_inicio_tarde"]: report.hora_inicio_tarde,
            ["hora_termino_tarde"]: report.hora_termino_tarde,
            ["total_horas_tarde"]: report.total_horas_tarde,
            ["total_adicional_dia"]: report.total_adicional_dia,
            ["total_laboral_dia"]: report.total_laboral_dia,
            ["horas_sabado"]: report.horas_sabado,
            ["horas_dyf"]: report.horas_dyf,
            ["horas_minimas_dia"]: report.horas_minimas_dia,
            ["horas_incluidas_operador"]: report.horas_incluidas_operador,
            ["valor_hora_adicional_uf"]: report.valor_hora_adicional_uf,
            ["valor_hora_adicional_sabados_uf"]: report.valor_hr_adicional_operador_s,
            ["valor_hora_adicional_domingos_festivos_uf"]: report.valor_hr_adicional_operador_df,
            ["horas_facturar_grua"]: report.horas_facturar_grua,
            ["dias_facturar_grua"]: report.dias_facturar_grua,
            ["dias_del_mes"]: report.dias_del_mes

          };
        } else {
          // Si el checkbox está desmarcado, eliminar el elemento correspondiente
          delete updatedData[report.id_report_gt];
        }
        return updatedData;
      });

      return newState;
    });
  };

  //Checkbox seleccionar todos los reports GT
  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    dataReports.forEach((item, index) => {
      const isChecked = newSelectAll;
      const dummyEvent = { target: { dataset: { legacy: "true" } } };
      if (checkboxStatesRepGT[index] !== isChecked) {
        toggleCheckboxRepGT(
          index,
          isChecked,
          item,
          dummyEvent
        );
      }
    });
  };

  function convertirHoraADecimal(hora) {
    const partes = hora.split(':');
    const horas = parseInt(partes[0]);
    const minutos = parseInt(partes[1]) / 60;
    const segundos = parseInt(partes[2]) / 3600;
    return horas + minutos + segundos;
  }

  function esDiaLaboral(fecha) {
    const diaSemana = fecha.getDay();

    const festivos = diasFestivos.map(festivo => {
      const [year, month, day] = festivo.fecha.split("-");
      return `${month}-${day}`;
    });

    const finDeSemana = [0, 6]; // Domingo (0) y Sábado (6)

    const esFestivo = festivos.includes(`${fecha.getMonth() + 1}-${fecha.getDate()}`);

    // Es día laboral si no es fin de semana ni festivo
    return !finDeSemana.includes(diaSemana) && !esFestivo;
  }

  const [dataTotalesGT, setDataTotalesGT] = useState({
    total_neto: 0,
    iva: 0,
    total: 0
  });

  const [selectedRowsServicios, setSelectedRowsServicios] = useState({});

  const calcularUFultimoDia = () => {
    // Fecha en formato ISO local yyyy-mm-dd
    const fechaActualISO = new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60 * 1000)).toISOString().split('T')[0];

    // Obtener year-month-day desde dataConsultaReports o usar la fecha actual
    const [year, month, day] = dataConsultaReports.fecha_hasta_ep !== ""
      ? dataConsultaReports.fecha_hasta_ep.split('-')
      : fechaActualISO.split('-');

    // Formato para comparar con toLocaleDateString('es-CL'): dd-mm-yyyy
    const fechaUltimoDiaEP = `${day}-${month}-${year}`;

    // Función auxiliar que busca en una serie y devuelve el item o null
    const buscarEnSerie = (data) => {
      if (!data || !data.serie || !Array.isArray(data.serie)) return null;
      return data.serie.find(item => {
        const itemDate = new Date(item.fecha).toLocaleDateString('es-CL');
        return itemDate === fechaUltimoDiaEP;
      }) || null;
    };

    // Buscar primero en el año actual
    const fechaActualIndicadorUF = buscarEnSerie(UFmensual)
      // si no está, buscar en el año pasado
      || buscarEnSerie(UFmensualPasado);

    // Si no se encontró en ninguno, manejar null para evitar errores
    const UFultimoDiaMes = fechaActualIndicadorUF && typeof fechaActualIndicadorUF.valor === 'number'
      ? Number(fechaActualIndicadorUF.valor / 1000)
      : null; 
    return { UFultimoDiaMes, fechaActualIndicadorUF };
  };

  useEffect(() => {
    const suma = Object.values(dataReportsGT).reduce(
      (accumulator, item) => {
        accumulator.total_horas_laborales += parseFloat(item.total_laboral_dia);
        accumulator.total_horas_no_laborales += parseFloat(item.total_adicional_dia);
        accumulator.total_horas_minimas += parseFloat(item.horas_minimas_dia);
        accumulator.total_horas_incluidas_operador += parseFloat(item.horas_incluidas_operador);
        accumulator.total_sabados += parseFloat(item.horas_sabado);
        accumulator.total_dyf += parseFloat(item.horas_dyf);

        return accumulator;
      },
      { total_horas_laborales: 0, total_horas_no_laborales: 0, total_sabados: 0, total_dyf: 0, total_horas_minimas: 0, total_horas_incluidas_operador: 0 }
    );

    //Cálculo de valores con fecha del último día de arriendo
    const { UFultimoDiaMes } = calcularUFultimoDia(dataConsultaReports);

    let ValorTotalHorasAdicionales;

    const hh_adic_sab_uf = dataDetalleOperador.valor_hora_adicional_sabados_uf ? Number(dataDetalleOperador.valor_hora_adicional_sabados_uf).toFixed(2) : 0;
    const hh_adic_lv_uf = dataDetalleOperador.valor_hora_adicional_uf ? Number(dataDetalleOperador.valor_hora_adicional_uf).toFixed(2) : 0;
    const hh_adic_dyf = dataDetalleOperador.valor_hora_adicional_domingos_festivos_uf ? Number(dataDetalleOperador.valor_hora_adicional_domingos_festivos_uf).toFixed(2) : 0;

    if (suma.total_horas_no_laborales !== 0) {
      ValorTotalHorasAdicionales = Number((suma.total_horas_laborales - suma.total_horas_incluidas_operador) * hh_adic_lv_uf * (UFultimoDiaMes * 1000))
    } else {
      ValorTotalHorasAdicionales = 0
    }

    // Totales Operador
    const nuevoArregloOperador = Object.entries(dataReportsGT).map(([id, item]) => ({
      horas_trabajadas_cantidad: Number(suma.total_horas_laborales).toFixed(2),
      horas_incluidas_operador: Number(suma.total_horas_incluidas_operador).toFixed(2),
      horas_adicionales: Number(suma.total_horas_laborales - suma.total_horas_incluidas_operador).toFixed(2),
      horas_adicionales_sabados: Number(suma.total_sabados).toFixed(2),
      horas_adicionales_domingos_festivos: Number(suma.total_dyf).toFixed(2),

      valor_hora_adicional_uf: hh_adic_lv_uf,
      valor_hora_adicional_sabados_uf: hh_adic_sab_uf,
      valor_hora_adicional_domingos_festivos_uf: hh_adic_dyf,
      valor_uf_fecha_facturacion: Number(dataDetalleOperador.valor_uf_fecha_facturacion),
      valor_total_horas_adicionales: ValorTotalHorasAdicionales
    }));

    const resultadosUnicosOperador = Array.from(
      new Set(nuevoArregloOperador.map(JSON.stringify)),
      JSON.parse
    );

    setDataTotalesOperador(resultadosUnicosOperador);
    // Totales Grúa
    // console.info('dataDetalleGrua------>', dataDetalleGrua)
    // console.info('dataReportsGT------>', dataReportsGT)
    const nuevoArregloGrua = Object.entries(dataReportsGT).map(([id, item]) => {

      // ✅ Cálculo correcto de horas incluidas
      const horasIncluidasGrua = dataDetalleGrua.dias_facturar_grua && dataDetalleGrua.horas_por_dia
        ? Number(dataDetalleGrua.dias_facturar_grua) * Number(dataDetalleGrua.horas_por_dia)
        : Number(dataDetalleGrua.horas_incluidas_grua);

      return {
        horas_trabajadas_cantidad: Number(suma.total_horas_laborales).toFixed(2),
        horas_facturar_grua: dataDetalleGrua.horas_facturar_grua,
        dias_facturar_grua: dataDetalleGrua.dias_facturar_grua,
        dias_del_mes: dataDetalleGrua.dias_del_mes,

        // ✅ Aquí va el valor corregido
        horas_incluidas_grua: Number(horasIncluidasGrua.toFixed(2)),

        horas_adicionales: Math.max(
          Number((dataDetalleGrua.horas_facturar_grua - horasIncluidasGrua).toFixed(2)),
          0
        ).toFixed(2),

        valor_hora_adicional_uf: Math.max(0, dataDetalleGrua.valor_hora_adicional_uf).toFixed(2),
        valor_uf_fecha_facturacion: Number(dataDetalleGrua.valor_uf_fecha_facturacion),

        valor_total_horas_adicionales:
          dataDetalleGrua.horas_facturar_grua - horasIncluidasGrua > 0
            ? Number(
              Number(
                (dataDetalleGrua.horas_facturar_grua - horasIncluidasGrua) *
                dataDetalleGrua.valor_hora_adicional_uf
              ).toFixed(2) *
              (UFultimoDiaMes * 1000)
            ).toFixed(0)
            : 0
      };
    });

    // console.info('nuevoArregloGrua------>', nuevoArregloGrua)
    const resultadosUnicosGrua = Array.from(
      new Set(nuevoArregloGrua.map(JSON.stringify)),
      JSON.parse
    );

    setDataTotalesGrua(resultadosUnicosGrua);

    setEstadoPagoData({
      ...dataEstadoPago,
      ["horas_trabajadas_cantidad"]: Number(suma.total_horas_laborales).toFixed(2),
      ["horas_incluidas_operador"]: resultadosUnicosOperador.length > 0 ? resultadosUnicosOperador[0].horas_incluidas_operador : 0,
      ["horas_adicionales_operador"]: resultadosUnicosOperador.length > 0 ? resultadosUnicosOperador[0].horas_adicionales : 0,
      ["valor_hora_adicional_uf_operador"]: resultadosUnicosOperador.length > 0 ? resultadosUnicosOperador[0].valor_hora_adicional_uf : 0,
      ["horas_adicionales_domingos_festivos_operador"]: resultadosUnicosOperador.length > 0 ? resultadosUnicosOperador[0].horas_adicionales_domingos_festivos : 0,
      ["valor_hora_adicional_domingos_festivos_uf_operador"]: resultadosUnicosOperador.length > 0 ? resultadosUnicosOperador[0].valor_hora_adicional_domingos_festivos_uf : 0,
      ["valor_total_horas_adicionales_operador"]: resultadosUnicosOperador.length > 0 ? Math.round(Number(resultadosUnicosOperador[0].valor_total_horas_adicionales)) : 0,
      ["horas_incluidas_grua"]: resultadosUnicosGrua.length > 0 ? resultadosUnicosGrua[0].horas_incluidas_grua : 0,
      ["horas_adicionales_grua"]: resultadosUnicosGrua.length > 0 ? resultadosUnicosGrua[0].horas_adicionales : 0,
      ["valor_hora_adicional_uf_grua"]: resultadosUnicosGrua.length > 0 ? resultadosUnicosGrua[0].valor_hora_adicional_uf : 0,
      ["valor_total_horas_adicionales_grua"]: resultadosUnicosGrua.length > 0 ? Math.round(Number(resultadosUnicosGrua[0].valor_total_horas_adicionales)) : 0,
      ["valor_uf_fecha_facturacion"]: resultadosUnicosGrua.length > 0 ? Number(resultadosUnicosGrua[0].valor_uf_fecha_facturacion) : 0,
      ["total_neto"]: dataTotalesGT.total_neto ? Math.round(dataTotalesGT.total_neto) : 0,
      ["iva"]: dataTotalesGT.iva ? Math.round(dataTotalesGT.iva) : 0,
      ["total"]: dataTotalesGT.total ? Math.round(dataTotalesGT.total) : 0
    });
  }, [dataReportsGT, UFmensual]);

  useEffect(() => {
    // const valorOperador = dataTotalesOperador[0]?.valor_total_horas_adicionales || 0;
    // const valorGrua = dataTotalesGrua[0]?.valor_total_horas_adicionales || 0;

    const totalNeto = Number(valorServicios);
    const nuevoTotalNeto = Math.round(totalNeto);
    const nuevoIva = Math.round(totalNeto * 0.19);
    const nuevoTotal = Math.round(totalNeto * 1.19);

    const totalesSonIguales = dataTotalesGT.total_neto === nuevoTotalNeto && dataTotalesGT.iva === nuevoIva && dataTotalesGT.total === nuevoTotal;

    if (!totalesSonIguales) {
      const nuevosTotales = {
        total_neto: nuevoTotalNeto,
        iva: nuevoIva,
        total: nuevoTotal
      };

      setDataTotalesGT(nuevosTotales);
      setEstadoPagoData(prev => ({ ...prev, ...nuevosTotales }));
    }
  }, [dataTotalesOperador, dataTotalesGrua, serviciosSeleccionados]);


  const validaFormularioBuscarReports = () => {
    if (clienteSelected === "") {
      alert('Debe seleccionar un cliente');
      return false;
    }

    if (dataConsultaReports.folio_ep.trim() === '') {
      alert('Debe seleccionar un folio');
      return false;
    }

    if (dataConsultaReports.fecha_desde_ep.trim() === '') {
      alert('Debe indicar una fecha desde');
      return false;
    }

    if (dataConsultaReports.fecha_hasta_ep.trim() === '') {
      alert('Debe indicar una fecha hasta');
      return false;
    }

    return true;
  }

  const [dataOtrosDescuentos, setOtrosDescuentos] = useState(0);
  const [dataTotalNetoInicial, setTotalNetoInicial] = useState(0);

  const handleOtrosDescuentos = (otro_descuento, total_neto_valor) => {
    console.info(otro_descuento, total_neto_valor)
    if (/^\d*$/.test(otro_descuento)) {
      const nuevoDescuento = Number(otro_descuento) || 0;
      setOtrosDescuentos(nuevoDescuento);
      const totalNeto = Number(total_neto_valor);
      // alert(dataTotalNetoInicial)
      if (dataTotalNetoInicial === 0) {

        setTotalNetoInicial(totalNeto);

        let totalNetoMostrado = nuevoDescuento === 0 ? totalNeto : totalNeto - nuevoDescuento;
        dataTotalesGT.total_neto = Math.round(totalNetoMostrado)
        dataTotalesGT.iva = Math.round(totalNetoMostrado * 0.19)
        dataTotalesGT.total = Math.round(totalNetoMostrado * 1.19)

        setEstadoPagoData({
          ...dataEstadoPago,
          ["otros_descuentos_ep"]: nuevoDescuento,
          ["total_neto"]: dataTotalesGT.total_neto,
          ["iva"]: dataTotalesGT.iva,
          ["total"]: dataTotalesGT.total
        });
      } else {
        let totalNetoConDescuento = totalNeto - nuevoDescuento;
        let totalNetoMostrado = nuevoDescuento === 0 ? totalNeto : totalNetoConDescuento;
        dataTotalesGT.total_neto = Math.round(totalNetoMostrado)
        dataTotalesGT.iva = Math.round(totalNetoMostrado * 0.19)
        dataTotalesGT.total = Math.round(totalNetoMostrado * 1.19)

        setEstadoPagoData({
          ...dataEstadoPago,
          ["otros_descuentos_ep"]: nuevoDescuento,
          ["total_neto"]: dataTotalesGT.total_neto,
          ["iva"]: dataTotalesGT.iva,
          ["total"]: dataTotalesGT.total
        });
      }
    }
  };

  //Submit
  const handleSubmitEstadoPagoGT = async (event) => {
    event.preventDefault();

    try {
      const esFormularioValido = validaFormularioSubmit();


      const idsServicios = new Set(
        serviciosSeleccionados.map(s => s.id_servicio)
      );
      const serviciosCalculados = dataServiciosFolio.filter(
        item => idsServicios.has(item.id_servicio)
      );
      // valida que al menos un servicio este seleccionado
      const hayServicios = obj => Object.keys(obj).length === 0 || Object.values(obj).every(v => v === false);

      if (Object.keys(dataReportsGT).length === 0 && hayServicios(serviciosCalculados)) {
        alert('Debe agregar al menos un report o servicio');
      } else if (esFormularioValido) {
        const data = {
          dataReportsGT: dataReportsGT,
          selectedRowsServicios: serviciosCalculados,
          dataEstadoPago: dataEstadoPago
        }

        const response = await fetch(
          `${config.apiBaseUrl}/estado_pago_gt.php`,
          {
            method: "POST",
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
          }
        );

        const dataResponse = await response.json();

        if (dataResponse.message === "Estado de pago agregado con éxito.") {
          setEstadoPagoData({
            folio_ep: "",
            id_obra_ep: "",
            id_cliente_ep: "",
            id_cliente_final_ep: "",
            horas_trabajadas_cantidad: "",
            horas_incluidas_operador: "",
            horas_adicionales_operador: "",
            valor_hora_adicional_uf_operador: "",
            horas_adicionales_domingos_festivos_operador: "",
            valor_hora_adicional_domingos_festivos_uf_operador: "",
            valor_total_horas_adicionales_operador: "",
            horas_incluidas_grua: "",
            horas_adicionales_grua: "",
            valor_hora_adicional_uf_grua: "",
            valor_total_horas_adicionales_grua: "",
            valor_uf_fecha_facturacion: "",
            otros_descuentos_ep: "",
            detalle_otros_descuentos_ep: "",
            total_neto: "",
            iva: "",
            total: "",
            id_usuario: ""
          });

          setDataReportsGT([]);
          setDataServiciosFolio([]);

          alert("Estado de pago agregado con éxito.");

          navigate("/dashboard", { state: dataLogin });

          onClose();
        } else {
          throw new Error();
        }

      }
    } catch (error) {
      console.log(error);
    }
  }

  const validaFormularioSubmit = () => {
    if (clienteSelected === "") {
      alert('Debe seleccionar un cliente');
      return false;
    }

    if (dataEstadoPago.folio_ep.trim() === '') {
      alert('Debe seleccionar un folio');
      return false;
    }

    if (dataConsultaReports.fecha_desde_ep.trim() === '') {
      alert('Debe indicar una fecha desde');
      return false;
    }

    if (dataConsultaReports.fecha_hasta_ep.trim() === '') {
      alert('Debe indicar una fecha hasta');
      return false;
    }

    if (dataEstadoPago.otros_descuentos_ep !== 0) {
      if (dataEstadoPago.detalle_otros_descuentos_ep.trim() === '') {
        alert('Debe indicar el detalle de otros descuentos, de lo contrario su valor debe ser 0');
        return false;
      }
    }

    return true;
  }

  // ✅ 1. Fila base fuera del componente
  const filaBase = {
    folio: "",
    id_servicio: null,
    id_maquinaria: 0,
    nombre_maquinaria: "",
    id_equipo: 0,
    tipo_arriendo: "Ninguno",
    glosa_servicio: "",
    cantidad_minima: 0,
    id_unidad_medida: null,
    unidad_medida: "",
    valor_unitario_neto: 0,
    valor_maximo: null,
    valor_normal: null,
    valor_total: 0,
    valor_parcial_neto: null,
    tipo_facturacion: "",
    tramos: null,
    fecha_telescopaje: null,
    valor_unitario_base: 0,
    observacion: "",
  };

  const TablaServicios = ({ usarTarifa, setUsarTarifa, dataServiciosFolio, indicadorUF, diasMes, diasFacturar, heGrua, heOp, heOpDF, setDataServiciosFolio, onValorServiciosChange, fechaHastaEEPP }) => {
    // IMPORTANTE
    // dataServiciosFolio → todos los servicios (no sirve para facturación)
    // selectedRowsServicios → solo los facturados
    // normalizados → solo para mostrar (no sirve para payload)    

    const [tempValues, setTempValues] = useState({});
    const [valorServicios, setValorServicios] = useState(0);
    const idExtrasGrua = [88, 207, 225];
    const idExtrasOp = [206, 227, 228, 256];
    const idExtrasOpDF = [205];
    const idTramos = [100, 112, 116, 117];
    const [tempFecha, setTempFecha] = useState({});
    const [tempTramos, setTempTramos] = useState({});
    const [tempObservacion, setTempObservacion] = useState({});


    const getValorBase = (fila, index) => {
      return usarTarifa
        ? Number(fila.valor_maximo ?? fila.valor_unitario_neto * 1) //1.8
        : Number(tempValues[index] ?? fila.valor_unitario_neto) || 0;
    };

    const normalizados = dataServiciosFolio.map(fila => {
      const unitarioBase = Number(fila.valor_unitario_base ?? fila.valor_unitario_neto) || 0;
      const maximo = fila.valor_maximo != null ? Number(fila.valor_maximo) : unitarioBase * 1; //1.8

      return {
        ...fila,
        valor_unitario_base: unitarioBase, // 👈 base "original" inmutable para cálculos de tarifa
        cantidad_minima: unitarioBase ? Number(fila.cantidad_minima) || 0 : 0,
        valor_unitario_neto: Number(fila.valor_unitario_neto) || unitarioBase,
        valor_parcial_neto: fila.valor_parcial_neto != null ? Number(fila.valor_parcial_neto) : null,
        valor_maximo: fila.valor_maximo !== null && fila.valor_maximo !== undefined
          ? Number(fila.valor_maximo)
          : null,
      };
    });

    const esHHExtra = (id) => idExtrasGrua.includes(id) || idExtrasOp.includes(id);
    const esExtra = (id) => {
      id = Number(id);
      return (
        idExtrasGrua.includes(id) ||
        idExtrasOp.includes(id) ||
        idExtrasOpDF.includes(id)
      );
    };

    useEffect(() => {
      const total = calculateTotal();

      // Solo actualiza si el total cambió
      if (total !== valorServicios) {
        setValorServicios(total);
        onValorServiciosChange?.(total);
      }
    }, [indicadorUF, selectedRowsServicios, valorServicios]);

    // Función segura para convertir un valor a número con 4 decimales
    const safeToFixed = (value, dec = 4) => {
      const num = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : Number(value) || 0;
      return Number(num.toFixed(dec)).toFixed(4);
    };

    // Selecciona/deselecciona todas las filas SOLO en este componente
    const toggleAllRows = (e) => {
      if (!document.getElementById("tabla-servicios-wrapper").contains(e.target)) return;

      const isChecked = e.target.checked;
      const newSelected = {};

      if (isChecked) {
        normalizados.forEach((_, index) => {
          newSelected[index] = true;
        });
      }
      setSelectedRowsServicios(newSelected); // ✅ solo actualiza selección
    };

    const toggleRow = (index, e) => {
      if (!document.getElementById("tabla-servicios-wrapper").contains(e.target)) return;

      setSelectedRowsServicios(prev => {
        const newSelected = { ...prev, [index]: !prev[index] };
        return newSelected;
      });
    };

    useEffect(() => {
      const newSelectedKeys = Object.keys(selectedRowsServicios).filter(
        key => selectedRowsServicios[key]
      );

      const nuevosServicios = newSelectedKeys.map(key => {
        const index = parseInt(key);
        const servicio = dataServiciosFolio[index];

        let valor_total = 0;

        const esExtraGrua = idExtrasGrua.includes(servicio.id_servicio);
        const esExtraOp = idExtrasOp.includes(servicio.id_servicio);
        const esExtraOpDF = idExtrasOpDF.includes(servicio.id_servicio);

        // ✅ 1. HH EXTRAS → SIEMPRE usan valor_unitario_neto (NO tarifa máxima)
        if (esExtraGrua || esExtraOp || esExtraOpDF) {
          const multiplicador = esExtraGrua
            ? heGrua
            : esExtraOp
              ? heOp
              : heOpDF;

          valor_total = Number(servicio.valor_unitario_neto * multiplicador).toFixed(4);

          return {
            ...servicio,
            valor_total: valor_total * indicadorUF
          };
        }

        // ✅ 2. Servicios normales → lógica existente
        if (servicio.valor_parcial_neto) {
          if (esExtraGrua)
            valor_total = Number(calcularParcialUF(servicio) * heGrua).toFixed(4);
          else if (esExtraOp)
            valor_total = Number(calcularParcialUF(servicio) * heOp).toFixed(4);
          else if (esExtraOpDF)
            valor_total = Number(calcularParcialUF(servicio) * heOpDF).toFixed(4);
          else
            valor_total = Number(calcularParcialUF(servicio));
        } else {
          if (esExtraGrua)
            valor_total = Number(servicio.valor_unitario_neto * heGrua).toFixed(4);
          else if (esExtraOp)
            valor_total = Number(servicio.valor_unitario_neto * heOp).toFixed(4);
          else if (esExtraOpDF)
            valor_total = Number(servicio.valor_unitario_neto * heOpDF).toFixed(4);
          else
            valor_total = Number(servicio.valor_unitario_neto).toFixed(4);
        }

        return {
          ...servicio,
          valor_total: valor_total * indicadorUF
        };
      });

      const jsonActual = JSON.stringify(serviciosSeleccionados);
      const jsonNuevo = JSON.stringify(nuevosServicios);

      if (jsonActual !== jsonNuevo) {
        setServiciosSeleccionados(nuevosServicios);
      }
    }, [selectedRowsServicios, indicadorUF]);

    // Calcula el total SOLO con las filas seleccionadas en este componente
    const calculateTotal = () => {
      return normalizados.reduce((sum, row, index) => {
        if (selectedRowsServicios[index] === true) {
          return sum + (row.valor_total ?? 0);
        }
        return sum;
      }, 0);
    };

    const handleChange = (index, value) => {
      if (/^\d*\.?\d{0,4}$/.test(value)) {
        setTempValues(prev => ({ ...prev, [index]: value }));
      }
    };

    // Agrega una fila nueva vacía con select para elegir servicio
    const agregarFila = () => {
      // 1. Agregar la fila base al arreglo principal
      setDataServiciosFolio(prev => [...prev, { ...filaBase }]);

      // 2. Obtener el índice de la nueva fila
      const newIndex = dataServiciosFolio.length;

      // 3. Inicializar temporales
      setTempValues(prev => ({
        ...prev,
        [newIndex]: ""
      }));

      setTempFecha(prev => ({
        ...prev,
        [newIndex]: ""
      }));

      setTempTramos(prev => ({
        ...prev,
        [newIndex]: ""
      }));
    };

    // Actualiza el servicio seleccionado en la nueva fila
    // helper para truncar a 2 decimales
    const truncate2Dec = (num) => Math.floor(num * 100) / 100;

    const recalcularFilaConTarifa = (fila, usarTarifa) => {
      const nueva = { ...fila };
      const valorUF2Dec = parseFloat(indicadorUF.toFixed(2));

      // ✅ mensual → NO usar horas
      if (nueva.unidad_medida?.trim().toLowerCase() === "mensual") {
        nueva.valor_total = Math.round(
          parseFloat(nueva.valor_unitario_neto) * valorUF2Dec
        );
        return nueva;
      }

      // ✅ NO mensual → usar horas
      const hheeTrunc = truncate2Dec(nueva.cantidad_minima ?? 1);

      const ufPorUnidad =
        nueva.tipo_facturacion === "parcial"
          ? (nueva.valor_parcial_neto ?? nueva.valor_unitario_neto)
          : nueva.valor_unitario_neto;

      const totalUF = truncate2Dec(hheeTrunc * ufPorUnidad);

      nueva.valor_total = Math.round(totalUF * valorUF2Dec);
      nueva.cantidad_minima = hheeTrunc;

      return nueva;
    };

    const actualizarServicio = (index, id_servicio) => {
      console.info(dataServiciosFolio[0])
      const servicioSeleccionado = servicios.find(
        s => s.id_servicio === parseInt(id_servicio)
      );
      if (!servicioSeleccionado) return;
      console.info(servicioSeleccionado)
      // ✅ Usar la fila REAL, no la normalizada
      const filaActual = dataServiciosFolio[index];

      let filaActualizada = {
        ...filaActual, // ✅ mantiene TODOS los campos completos
        folio: servicioSeleccionado.folio ?? dataServiciosFolio[0].folio,
        id_servicio: Number(id_servicio),
        id_equipo: servicioSeleccionado.id_equipo ?? dataServiciosFolio[0].id_equipo,
        id_maquinaria: servicioSeleccionado.id_maquinaria ?? dataServiciosFolio[0].id_maquinaria,
        id_tipo_arriendo: servicioSeleccionado.id_tipo_arriendo ?? dataServiciosFolio[0].id_tipo_arriendo,
        id_tipo_maquinaria: servicioSeleccionado.id_tipo_maquinaria ?? dataServiciosFolio[0].id_tipo_maquinaria,
        glosa_servicio: servicioSeleccionado.glosa_servicio ?? "No definido",
        unidad_medida: servicioSeleccionado.unidad_medida ?? "No definido",
        id_unidad_medida: servicioSeleccionado.id_unidad_medida ?? null,
        valor_unitario_neto: servicioSeleccionado.valor_unitario_neto ?? 0,
        valor_unitario_base: servicioSeleccionado.valor_unitario_base ?? servicioSeleccionado.valor_unitario_neto,
        valor_normal: servicioSeleccionado.valor_normal ?? servicioSeleccionado.valor_unitario_neto,
        valor_maximo: servicioSeleccionado.valor_maximo ?? servicioSeleccionado.valor_unitario_neto * 1,//1.8
        cantidad_minima: 1,
        tipo_facturacion: filaActual.tipo_facturacion ?? "",
        valor_parcial_neto: filaActual.valor_parcial_neto ?? null,
      };

      // ✅ reglas especiales: asignar hhee
      if (idExtrasGrua.includes(filaActualizada.id_servicio)) {
        filaActualizada.cantidad_minima = heGrua;
      } else if (idExtrasOp.includes(filaActualizada.id_servicio)) {
        filaActualizada.cantidad_minima = heOp;
      } else if (idExtrasOpDF.includes(filaActualizada.id_servicio)) {
        filaActualizada.cantidad_minima = heOpDF;
      }

      const valorUF2Dec = parseFloat(indicadorUF.toFixed(2));

      // ✅ Mensual
      if (filaActualizada.unidad_medida === "Mensual") {
        filaActualizada.valor_total = Math.round(
          parseFloat(filaActualizada.valor_unitario_neto) * valorUF2Dec
        );

        setDataServiciosFolio(prev =>
          prev.map((fila, i) => (i === index ? filaActualizada : fila))
        );

        setTempValues(prev => ({
          ...prev,
          [index]: filaActualizada.valor_unitario_neto.toString()
        }));

        return;
      }

      // ✅ Horas normales
      const hheeTrunc = truncate2Dec(filaActualizada.cantidad_minima);

      let ufPorUnidad;

      if (esHHExtra(filaActualizada.id_servicio)) {
        ufPorUnidad = filaActualizada.valor_unitario_neto;
      } else {
        ufPorUnidad =
          filaActualizada.tipo_facturacion === "parcial"
            ? (filaActualizada.valor_parcial_neto ?? filaActualizada.valor_unitario_neto)
            : filaActualizada.valor_unitario_neto;
      }

      const totalUF = truncate2Dec(hheeTrunc * ufPorUnidad);

      filaActualizada.valor_total = Math.round(totalUF * valorUF2Dec);
      filaActualizada.cantidad_minima = hheeTrunc;
      filaActualizada.valor_parcial_neto = ufPorUnidad;

      setDataServiciosFolio(prev =>
        prev.map((fila, i) => (i === index ? filaActualizada : fila))
      );

      setTempValues(prev => ({
        ...prev,
        [index]: ufPorUnidad.toString()
      }));
    };


    //Elimina fila de servicios en el EEPP
    const eliminarFila = (index) => {
      // 1. Eliminar la fila real
      setDataServiciosFolio(prev => prev.filter((_, i) => i !== index));

      // 2. Reindexar tempValues
      setTempValues(prev => {
        const copy = {};
        Object.keys(prev).forEach(key => {
          const k = Number(key);
          if (k !== index) {
            copy[k > index ? k - 1 : k] = prev[k];
          }
        });
        return copy;
      });

      // 3. Reindexar tempFecha (si lo usas)
      setTempFecha(prev => {
        const copy = {};
        Object.keys(prev).forEach(key => {
          const k = Number(key);
          if (k !== index) {
            copy[k > index ? k - 1 : k] = prev[k];
          }
        });
        return copy;
      });

      // 4. Reindexar tempTramos (si lo usas)
      setTempTramos(prev => {
        const copy = {};
        Object.keys(prev).forEach(key => {
          const k = Number(key);
          if (k !== index) {
            copy[k > index ? k - 1 : k] = prev[k];
          }
        });
        return copy;
      });
    };


    const calcularParcialUF = (servicio) => {
      // console.info(servicio.valor_unitario_neto, diasMes, diasFacturar)
      const valorParcial = (servicio.valor_unitario_neto / diasMes) * diasFacturar;
      return Number(valorParcial.toFixed(4));
    };

    const actualizarParcial = (index, tipoSeleccionado) => {
      const nuevosDatos = [...normalizados];
      nuevosDatos[index].tipo_facturacion = tipoSeleccionado;

      if (tipoSeleccionado === "parcial") {
        const parcialUF = calcularParcialUF(nuevosDatos[index]);
        nuevosDatos[index].valor_parcial_neto = parcialUF;
        nuevosDatos[index].valor_total = parcialUF * indicadorUF;
      } else {
        nuevosDatos[index].valor_parcial_neto = null;
        nuevosDatos[index].valor_total = Math.round(nuevosDatos[index].valor_unitario_neto * indicadorUF);
        console.info(nuevosDatos[index].valor_unitario_neto, indicadorUF)
      }

      setDataServiciosFolio(nuevosDatos);

      setTempValues(prev => ({
        ...prev,
        [index]: (nuevosDatos[index].valor_parcial_neto ?? nuevosDatos[index].valor_unitario_neto).toString()
      }));
    };

    const handleBlur = (index) => {
      const fila = normalizados[index];
      const base = getValorBase(fila, index);

      const updatedData = [...normalizados];
      updatedData[index] = {
        ...updatedData[index],
        valor_unitario_neto: base,
        valor_total: Math.round(base * indicadorUF)
      };

      setDataServiciosFolio(updatedData);

      setTempValues(prev => ({
        ...prev,
        [index]: base.toString()
      }));
    };

    const handleFocus = (e, index) => {
      e.target.select();
      const fila = dataServiciosFolio[index];
      const base = getValorBase(fila, index);

      setTempValues(prev => ({
        ...prev,
        [index]: base.toString()
      }));
    };

    const handleToggleTarifa = () => {
      const nuevoEstado = !usarTarifa;
      setUsarTarifa(nuevoEstado);

      setDataServiciosFolio(prev =>
        prev.map((fila) => {
          const nueva = { ...fila };
          const id = Number(fila.id_servicio);

          const extra = esExtra(id);
          const tramo = idTramos.includes(id);

          // ✅ Si NO debe sentir tarifa → NO recalcular nada
          if (!extra && !tramo) {
            return fila; // ← dejarla intacta
          }

          // ✅ Si sí debe sentir tarifa → aplicar tarifa
          if (!extra) {
            nueva.valor_unitario_neto = nuevoEstado
              ? fila.valor_maximo
              : fila.valor_normal;
          }

          // ✅ Recalcular total SOLO para filas válidas
          nueva.valor_total = calcularTotal(
            nueva,
            indicadorUF,
            diasMes,
            nuevoEstado
          );

          return nueva;
        })
      );
    };

    const calcularTotal = (fila, indicadorUF, diasMes, usarTarifa) => {
      const id = Number(fila.id_servicio);
      const ufNum = Number(indicadorUF) || 0;

      const esExtraGrua = idExtrasGrua.includes(id);
      const esExtraOp = idExtrasOp.includes(id);
      const esExtraOpDF = idExtrasOpDF.includes(id);

      // ✅ 0. BYPASS HH EXTRAS → NO usan tarifa máxima, ni parcial, ni tramos, ni mensual
      if (esExtraGrua || esExtraOp || esExtraOpDF) {
        const multiplicador = esExtraGrua
          ? heGrua
          : esExtraOp
            ? heOp
            : heOpDF;

        const totalUF = Number(fila.valor_unitario_neto) * multiplicador;
        return Math.round(totalUF * ufNum);
      }

      // ✅ 1. Servicios de TRAMOS
      if (idTramos.includes(id)) {
        const tramos = Number(fila.tramos) || 0;

        // ✅ 1A. TRAMOS MENSUALES
        if (fila.id_unidad_medida === 7) {
          let valorMensualUF =
            usarTarifa && fila.valor_maximo != null
              ? Number(fila.valor_maximo)
              : Number(fila.valor_unitario_neto);

          const fechaTel = fila.fecha_telescopaje
            ? new Date(fila.fecha_telescopaje)
            : null;

          const fechaHasta = fechaHastaEEPP
            ? new Date(fechaHastaEEPP)
            : new Date(fechaTel.getFullYear(), fechaTel.getMonth() + 1, 0);

          if (fechaTel) {
            const diasTranscurridos =
              fechaHasta.getDate() - fechaTel.getDate() + 1;

            const parcialUF = (valorMensualUF / diasMes) * diasTranscurridos;

            return Math.round(parcialUF * ufNum * tramos);
          }

          return Math.round(valorMensualUF * ufNum * tramos);
        }

        // ✅ 1B. TRAMOS POR EVENTO
        if (fila.id_unidad_medida === 5) {
          const valorUF = usarTarifa
            ? Number(fila.valor_maximo) || 0
            : Number(fila.valor_unitario_neto) || 0;

          return Math.round(valorUF * ufNum * tramos);
        }
      }

      // ✅ 1C. Servicios MENSUALES que NO son tramos
      if (fila.id_unidad_medida === 7 && !idTramos.includes(id)) {
        const valorMensualUF = usarTarifa
          ? Number(fila.valor_maximo)
          : Number(fila.valor_unitario_neto);

        return Math.round(valorMensualUF * ufNum);
      }

      // ✅ 2. Servicios NORMALES
      const cantidad = Number(fila.cantidad_minima) || 0;
      const unitUF = usarTarifa
        ? Number(fila.valor_maximo) || 0
        : Number(fila.valor_unitario_neto) || 0;

      // ✅ Parcial mensual
      if (fila.tipo_facturacion === "parcial" && fila.fecha_telescopaje) {
        const fechaTel = new Date(fila.fecha_telescopaje);
        const diaTel = fechaTel.getDate();
        const diasFacturar = diaTel;

        const parcial = (unitUF / diasMes) * diasFacturar;
        return Math.round(parcial * cantidad * ufNum);
      }

      // ✅ Normal
      return Math.round(cantidad * unitUF * ufNum);
    };

    const actualizarCampo = (index, campo, valor) => {
      const updated = [...dataServiciosFolio];

      if (campo === "cantidad_minima" || campo === "valor_unitario_neto" || campo === "tramos") {
        // Normalizamos a número
        updated[index][campo] = Number(valor) || 0;
      } else if (campo === "fecha_telescopaje") {
        // Guardamos la fecha en formato ISO yyyy-mm-dd
        updated[index][campo] = valor ? valor : null;
      } else {
        // Otros campos se guardan tal cual
        updated[index][campo] = valor;
      }

      // Recalcular el total después de cualquier cambio
      updated[index].valor_total = calcularTotal(
        updated[index],
        indicadorUF,
        diasMes,
        usarTarifa
      );
      console.info('>>>>>>>>>>>>>>> ', updated)
      setDataServiciosFolio(updated);
      console.info('>>>>>>>>>>>>>>> ', dataServiciosFolio)
    };

    const getDisplayValue = (totales, index) => {
      if (usarTarifa) {
        return safeToFixed(
          totales.valor_maximo ?? totales.valor_unitario_neto * 2,
          4
        );
      }

      return totales.tipo_facturacion === "parcial"
        ? safeToFixed(totales.valor_parcial_neto ?? totales.valor_unitario_neto, 4)
        : safeToFixed(totales.valor_unitario_neto, 4);
    };

    return (
      <tbody>
        <tr className="table-active">
          <th className="ps-2" colSpan={8}>
            <div className="d-flex align-items-center justify-content-between">
              {/* Botón Nuevo Servicio */}
              <button onClick={agregarFila} className="btn btn-success mb-2">
                <i className="bi bi-plus-square-fill"></i> &nbsp;Nuevo Servicio
              </button>

              {/* Check global Tarifa */}
              <div className="form-check mb-2">
                <input
                  id="tarifaGlobal"
                  type="checkbox"
                  className="form-check-input"
                  checked={usarTarifa}
                  onChange={handleToggleTarifa}
                />
                <label className="form-check-label" htmlFor="tarifaGlobal">
                  Tarifa Máxima &nbsp;
                </label>
              </div>
            </div>
          </th>
        </tr>

        <tr className="table-active">
          <th className="ps-2" width="3%">
            <input
              className="form-check-input"
              type="checkbox"
              data-component="servicios"
              data-legacy="false"
              onChange={(e) => toggleAllRows(e)}
              checked={Object.keys(selectedRowsServicios).length === normalizados.length && normalizados.length > 0}
            />
          </th>
          <th></th>
          <th width="40%">Servicio</th>
          <th>Detalle</th>
          <th>Facturación</th>
          <th>Valor.Máx.UF</th>
          <th>Valor UF</th>
          <th className="pe-2">Valor $</th>
        </tr>

        {dataServiciosFolio.length > 0 ? (
          dataServiciosFolio.map((filas, index) => {
            const displayValue = getDisplayValue(filas, index);
            return (
              <tr key={filas.id_servicio}>
                <td className="align-middle ps-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    data-legacy="false"
                    checked={selectedRowsServicios[index] || false}
                    onChange={(e) => toggleRow(index, e)}
                  />
                </td>
                <td>
                  <button
                    onClick={() => eliminarFila(index)}
                    className="btn btn-link p-0 m-0 text-danger"
                  >
                    <i className="bi bi-trash fs-6"></i>
                  </button>
                </td>
                <td className="ps-2">
                  {filas.id_servicio ? (
                    `${filas.glosa_servicio}`
                  ) : (
                    <select
                      value={filas.id_servicio}
                      onChange={(e) => actualizarServicio(index, e.target.value)}
                      className="form-select form-select-sm"
                    >
                      <option value="">Seleccione...</option>
                      {servicios.map((servicio) => (
                        <option key={servicio.id_servicio} value={servicio.id_servicio}>
                          {servicio.glosa_servicio} - {servicio.unidad_medida} : {servicio.valor_unitario_neto}
                        </option>
                      ))}
                    </select>
                  )}
                </td>
                <td>
                  <input
                    type="text"
                    className="form-control-tramos form-control-sm"
                    value={
                      tempObservacion[index] !== undefined
                        ? tempObservacion[index]
                        : filas.observacion ?? ""
                    }
                    onChange={(e) => {
                      setTempObservacion(prev => ({
                        ...prev,
                        [index]: e.target.value
                      }));
                    }}
                    onBlur={(e) => {
                      actualizarCampo(index, "observacion", e.target.value);

                      setTempObservacion(prev => {
                        const copy = { ...prev };
                        delete copy[index];
                        return copy;
                      });
                    }}
                    maxLength={15}
                    style={{ width: "160px" }}
                  />
                </td>
                <td>
                  {idTramos.includes(Number(filas.id_servicio)) ? (
                    <div className="d-flex gap-2">
                      <input
                        type="text"
                        className="form-control form-control-sm text-end"
                        value={tempTramos[index] ?? filas.tramos ?? ""}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (/^\d*$/.test(val)) {
                            setTempTramos(prev => ({ ...prev, [index]: val }));
                          }
                        }}
                        onBlur={(e) => {
                          const val = e.target.value;
                          actualizarCampo(index, "tramos", val === "" ? null : Number(val));
                          setTempTramos(prev => {
                            const copy = { ...prev };
                            delete copy[index];
                            return copy;
                          });
                        }}
                        style={{ width: "40px" }}
                      />

                      <input
                        type="date"
                        className="form-control form-control-sm text-end"
                        value={
                          tempFecha[index] !== undefined
                            ? tempFecha[index]
                            : filas.fecha_telescopaje || ""
                        }
                        onChange={(e) => {
                          const val = e.target.value;
                          setTempFecha(prev => ({ ...prev, [index]: val }));
                        }}
                        onBlur={(e) => {
                          const val = e.target.value;
                          actualizarCampo(index, "fecha_telescopaje", val);
                          setTempFecha(prev => {
                            const copy = { ...prev };
                            delete copy[index];
                            return copy;
                          });
                        }}
                        style={{ width: "125px" }}
                        onClick={(e) => e.stopPropagation()}
                        onMouseDown={(e) => e.stopPropagation()}
                        onFocus={(e) => e.stopPropagation()}
                      />

                    </div>
                  ) : (
                    <select
                      className="form-select form-select-sm"
                      value={normalizados[index].tipo_facturacion ?? ""}
                      onChange={(e) => actualizarParcial(index, e.target.value)}
                      disabled={esExtra(Number(filas.id_servicio))}
                    >
                      <option value="">Seleccione…</option>
                      <option value="completa">Completa</option>
                      <option value="parcial">Parcial</option>
                    </select>)}
                </td>

                <td className="text-end">
                  {Number(filas.valor_maximo ?? tempValues[index] ?? displayValue ?? 0).toFixed(4)}
                </td>
                <td>
                  <input
                    className="form-control form-control-sm text-end"
                    type="text"
                    value={
                      tempValues[index] !== undefined
                        ? tempValues[index]
                        : getDisplayValue(filas, index)
                    }
                    onChange={(e) => {
                      const value = e.target.value;
                      setTempValues(prev => ({
                        ...prev,
                        [index]: value
                      }));
                    }}
                    onBlur={(e) => {
                      const value = e.target.value;
                      actualizarCampo(index, "valor_unitario_neto", value);
                      setTempValues(prev => {
                        const copy = { ...prev };
                        delete copy[index];
                        return copy;
                      });
                    }}
                    inputMode="decimal"
                    style={{ width: "100px" }}
                    disabled={usarTarifa}
                  />

                </td>
                <td className="pe-2 text-end">
                  <small className="text-secondary">$</small>
                  <span className="text-orange">
                    {Math.round(filas.valor_total).toLocaleString("es-ES", {
                      maximumFractionDigits: 0
                    })}
                  </span>
                </td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan={8} className="text-center">
              No se han encontrado servicios
            </td>
          </tr>
        )}
        <tr className="fw-bold">
          <td colSpan="7" className="text-end">Total servicios seleccionados:</td>
          <td className="text-end text-orange">${valorServicios.toLocaleString('es-ES', { maximumFractionDigits: 0 })}</td>
        </tr>
      </tbody>
    );
  };

  return (

    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xxl">
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="mb-0">Agregar Estado de Pago: Grúa Torre</h4>
          <button onClick={onClose} className="btn-close"></button>
        </div>
        <div className="modal-body py-3 px-5">
          <div className="row row-cols-lg-4 mb-3">
            <div className="col">
              <label className="form-label">Cliente</label>
              <Select
                name="id_cliente_ep"
                value={clienteSelected.value}
                onChange={handleClienteSelect}
                options={optionsClientes}
                isSearchable
                className="react-select"
                placeholder="Seleccione un cliente"
              />
            </div>
            <div className="col">
              <label className="form-label">Obra</label>
              <select className="form-select" name="id_obra_ep" value={dataConsultaReports.id_obra_ep} onChange={(e) => handleObraSelect(e.target.value)}>
                <option value="">Seleccione una obra</option>
                {clienteObra.map((obra, index) => (
                  <option key={index} value={obra.id_obra}>{obra.nombre}</option>
                ))}
              </select>
            </div>
            <div className="col">
              <label className="form-label">Cliente Final</label>
              <select className="form-select" name="id_cliente_final_ep" value={dataEstadoPago.id_cliente_final_ep} disabled>
                <option value="">Seleccione un cliente final</option>
                {optionsClientes.map((cliente_final, index) => (
                  <option key={index} value={cliente_final.value}>{cliente_final.label}</option>
                ))}
              </select>
            </div>
            {folios ? (
              <div className="col">
                <label className="form-label">Folio</label>
                <select className="form-select" name="folio_ep" value={dataEstadoPago.folio_ep} onChange={handleFormEstadoPagoData}>
                  <option value="">Seleccione un folio</option>
                  {folios.map((folio, index) => (
                    <option key={index} value={folio.folio}>{folio.folio} {folio.equipo !== "null null" ? "(" + folio.equipo + ")" : ""}</option>
                  ))}
                </select>
              </div>
            ) : (
              <div className="col">
                <label className="form-label">Folio</label>
                <select className="form-select" name="folio_ep">
                  <option value="">No se encontraron folios</option>
                </select>
              </div>
            )}
          </div>
          <div className="row row-cols-md-4 align-items-end mb-4">
            <div className="col">
              <label className="form-label">Fecha Desde</label>
              <input
                className="form-control"
                type="date"
                name="fecha_desde_ep"
                value={dataConsultaReports.fecha_desde_ep}
                max={today.toISOString().split('T')[0]}
                onChange={(e) => setDataConsultaReports({
                  ...dataConsultaReports,
                  fecha_desde_ep: e.target.value
                })}
              />
            </div>
            <div className="col">
              <label className="form-label">Fecha Hasta</label>
              <input
                className="form-control"
                type="date"
                name="fecha_hasta_ep"
                value={dataConsultaReports.fecha_hasta_ep}
                max={today.toISOString().split('T')[0]}
                onChange={(e) => setDataConsultaReports({
                  ...dataConsultaReports,
                  fecha_hasta_ep: e.target.value
                })}
              />
            </div>
            <div className="col">
              <label className="form-label d-block">&nbsp;</label>
              <button className="btn btn-dark" onClick={handleSubmitBuscarReports}>
                <i className="bi bi-search"></i> Buscar
              </button>
            </div>
          </div>
          <div className="d-flex justify-content-md-between mb-3">
            <h5 className="mb-0">Reports Grúa Torre</h5>
            <span className="d-inline-flex align-items-center">
              <label className="form-label mb-0 me-2">UF Facturación</label>
              <span className="fw-bold text-orange"><small className="text-secondary">$</small> {Number(UFFacturacion ? UFFacturacion : indicadorUF).toLocaleString('es-ES', { useGrouping: true })}</span>
            </span>
            <span className="d-inline-flex align-items-center">
              <label className="form-label mb-0 me-2">UF Hoy</label>
              <span className="fw-bold text-orange"><small className="text-secondary">$</small> {Number(indicadorUF ? indicadorUF : '0').toLocaleString('es-ES', { useGrouping: true })}</span>
            </span>
          </div>
          <div className="table-responsive border rounded mb-4">
            <table className="table table-hover table-sm text-center mb-0">
              <thead>
                <tr className="border-bottom">
                  <th scope="col" className="border-end" colSpan={6}>Report</th>
                  <th scope="col" className="border-start border-end" colSpan={3}>Mañana</th>
                  <th scope="col" className="border-start border-end" colSpan={3}>Tarde</th>
                  <th scope="col" className="border-start border-end" colSpan={3}>Horas</th>
                </tr>
                <tr className="table-active border-bottom">
                  <th scope="col">
                    {dataReports.length > 0 ? (
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={selectAll}
                          onChange={handleSelectAll}
                        />
                      </div>
                    ) : (
                      <span></span>
                    )}
                  </th>
                  <th scope="col">N°</th>
                  <th scope="col">Equipo</th>
                  <th scope="col">Fecha</th>
                  <th scope="col">Día</th>
                  <th scope="col">Mes</th>
                  <th scope="col">Hr Inicio</th>
                  <th scope="col">Hr Término</th>
                  <th scope="col">Hrs Mañana</th>
                  <th scope="col">Hr Inicio</th>
                  <th scope="col">Hr Término</th>
                  <th scope="col">Hrs Tarde</th>
                  {/* <th scope="col">Incluidas</th> */}
                  <th scope="col" colSpan={2}>Total</th>
                </tr>
              </thead>
              <tbody>
                {dataReports.length > 0 ? (
                  dataReports.map((report, index) => (
                    <tr key={index}>
                      <td>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            data-legacy="true"
                            checked={checkboxStatesRepGT[index] || false}
                            onChange={(e) => toggleCheckboxRepGT(index, e.target.checked, report, e)}
                          />
                        </div>
                      </td>
                      <td>{report.id_report_gt}</td>
                      <td>{report.numero}</td>
                      <td>{report.fecha_report}</td>
                      <td>{report.dia}</td>
                      <td>{report.mes}</td>
                      <td className="text-center border-start">{report.hora_inicio_manana.substring(0, 5)}</td>
                      <td className="text-center">{report.hora_termino_manana.substring(0, 5)}</td>
                      <td className="text-center border-end">{report.horas_manana.substring(0, 5)}</td>
                      <td className="text-center">{report.hora_inicio_tarde.substring(0, 5)}</td>
                      <td className="text-center">{report.hora_termino_tarde.substring(0, 5)}</td>
                      <td className="text-center border-end">{report.horas_tarde.substring(0, 5)}</td>
                      {/* <td className="text-center">{report.horas_minimas_dia_hhmm.substring(0, 5)}</td> */}
                      <td className="text-center">{report.total_laboral_dia}</td>
                      <td className="text-center">{report.total_laboral_dia_hhmm.substring(0, 5)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="text-center ps-1" colSpan={14}>No se encontraron reports</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="row row-cols-2 mb-4">
            <div className="col">
              <div className="d-flex justify-content-md-between mb-3">
                <h5 className="mb-0">Detalle Operador</h5>
                <span className="d-inline-flex align-items-center">
                  <label className="form-label mb-0 me-2">Horas Trabajadas:</label>
                  {dataTotalesOperador.length > 0 ? (
                    <span className="fw-bold text-orange">{dataTotalesOperador[0].horas_trabajadas_cantidad}</span>
                  ) : (
                    <span className="fw-bold text-orange">0</span>
                  )}
                </span>
              </div>
              <div className="table-responsive border rounded">
                <table className="table table-hover table-sm mb-0">
                  <thead>
                    <tr className="table-active border-bottom">
                      <th className="col-6 ps-2">Descripción</th>
                      <th className="col-2 pe-2">Detalle</th>
                    </tr>
                  </thead>
                  {dataTotalesOperador.length > 0 ? (
                    <tbody>
                      <tr>
                        <td className="ps-2">Horas Incluidas Operador</td>
                        <td className="pe-2 text-end">{dataTotalesOperador[0].horas_incluidas_operador}</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Horas Adicionales L-V </td>
                        <td className="pe-2 text-end">{dataTotalesOperador[0].horas_adicionales}</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Valor Hora Adicional L-V (UF)</td>
                        <td className="pe-2 text-end">{dataTotalesOperador[0].valor_hora_adicional_uf}</td>
                      </tr>
                      {/* <tr>
                        <td className="ps-2">Horas Adicionales Sábados</td>
                        <td className="pe-2 text-end">{dataTotalesOperador[0].horas_adicionales_sabados}</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Valor Horas Adicional Sábados(UF)</td>
                        <td className="pe-2 text-end">{dataTotalesOperador[0].valor_hora_adicional_sabados_uf}</td>
                      </tr> */}
                      <tr>
                        <td className="ps-2">Horas Adicionales Domingos y Festivos</td>
                        <td className="pe-2 text-end">{dataTotalesOperador[0].horas_adicionales_domingos_festivos}</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Valor Horas Adicional Domingos y Festivos(UF)</td>
                        <td className="pe-2 text-end">{dataTotalesOperador[0].valor_hora_adicional_domingos_festivos_uf}</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Valor UF a Fecha de Facturación</td>
                        <td className="pe-2 text-end"><small className="text-secondary">$</small> {dataTotalesOperador[0].valor_uf_fecha_facturacion.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Valor Total Horas Adicionales</td>
                        <td className="pe-2 text-end"><small className="text-secondary">$</small>
                          <span className="text-orange">
                            {Number(parseInt(dataTotalesOperador[0].valor_total_horas_adicionales)).toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td className="ps-2">Horas Incluidas Operador</td>
                        <td className="pe-2 text-end">0</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Horas Adicionales</td>
                        <td className="pe-2 text-end">0</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Valor Horas Adicional L-V (UF)</td>
                        <td className="pe-2 text-end">0</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Horas Adicionales Festivos</td>
                        <td className="pe-2 text-end">0</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Valor Horas Adicional Festivos (UF)</td>
                        <td className="pe-2 text-end">0</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Horas Adicionales Sábados</td>
                        <td className="pe-2 text-end">0</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Valor Horas Adicional Sábados(UF)</td>
                        <td className="pe-2 text-end">0</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Valor UF a Fecha de Facturación</td>
                        <td className="pe-2 text-end"><small className="text-secondary">$</small> 0</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Valor Total Horas Adicionales</td>
                        <td className="pe-2 text-end"><small className="text-secondary">$</small> <span className="text-orange">0</span></td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>
            <div className="col">
              <h5 className="mb-3">Detalle Grúa</h5>
              <div className="table-responsive border rounded">
                <table className="table table-hover table-sm mb-0">
                  <thead>
                    <tr className="table-active border-bottom">
                      <th className="col-6 ps-2">Descripción</th>
                      <th className="col-2 pe-2">Detalle</th>
                    </tr>
                  </thead>
                  {dataTotalesGrua.length > 0 ? (
                    <tbody>
                      <tr>
                        <td className="ps-2">Horas Incluidas Grúa</td>
                        <td className="pe-2 text-end">{dataTotalesGrua[0].horas_incluidas_grua}</td>
                      </tr>
                      {/* <tr>
                        <td className="ps-2">Horas Trabajadas Grúa</td>
                        <td className="pe-2 text-end fw-bold text-orange">{dataTotalesGrua[0].horas_facturar_grua}</td>
                      </tr> */}
                      <tr>
                        <td className="ps-2">Dias Trabajados Mes</td>
                        <td className="pe-2 text-end">{dataTotalesGrua[0].dias_facturar_grua} de {dataTotalesGrua[0].dias_del_mes}</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Horas Adicionales</td>
                        <td className="pe-2 text-end">{dataTotalesGrua[0].horas_adicionales}</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Valor Horas Adicional (UF)</td>
                        <td className="pe-2 text-end">{dataTotalesGrua[0].valor_hora_adicional_uf}</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Valor UF a Fecha de Facturación</td>
                        <td className="pe-2 text-end"><small className="text-secondary">$</small> {dataTotalesGrua[0].valor_uf_fecha_facturacion.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Valor Total Horas Adicionales</td>
                        <td className="pe-2 text-end"><small className="text-secondary">$</small> <span className="text-orange">
                          {Number(parseInt(dataTotalesGrua[0].valor_total_horas_adicionales)).toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                        </span></td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td className="ps-2">Horas Incluidas Grúa</td>
                        <td className="pe-2 text-end">0</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Horas Trabajadas Grúa</td>
                        <td className="pe-2 text-end">0</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Dias Trabajados</td>
                        <td className="pe-2 text-end">0  vs  0</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Horas Adicionales</td>
                        <td className="pe-2 text-end">0</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Valor Horas Adicional (UF)</td>
                        <td className="pe-2 text-end">0</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Valor UF a Fecha de Facturación</td>
                        <td className="pe-2 text-end"><small className="text-secondary">$</small> 0</td>
                      </tr>
                      <tr>
                        <td className="ps-2">Valor Total Horas Adicionales</td>
                        <td className="pe-2 text-end"><small className="text-secondary">$</small> <span className="text-orange">0</span></td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>
          </div>
          <h5 className="mb-3">Detalle Servicios</h5>
          <div id="tabla-servicios-wrapper" className="table-responsive border rounded mb-4">
            <table className="table table-hover table-sm mb-0" onClick={(e) => e.stopPropagation()}>
              <TablaServicios
                usarTarifa={usarTarifa}
                setUsarTarifa={setUsarTarifa}
                dataServiciosFolio={dataServiciosFolio}
                indicadorUF={UFFacturacion}
                diasMes={diasMes}
                diasFacturar={diasFacturar}
                heGrua={dataTotalesGrua.length > 0 ? parseFloat(dataTotalesGrua[0].horas_adicionales) : 0}
                heOp={dataTotalesOperador.length > 0 ? parseFloat(dataTotalesOperador[0].horas_adicionales + dataTotalesOperador[0].horas_adicionales_sabados) : 0}
                heOpDF={dataTotalesOperador.length > 0 ? parseFloat(dataTotalesOperador[0].horas_adicionales_domingos_festivos) : 0}
                setDataServiciosFolio={setDataServiciosFolio}
                onValorServiciosChange={handleValorServiciosChange}
                fechaHastaEEPP={dataConsultaReports.fecha_hasta_ep}
              />
            </table>
          </div>
          <div className="row row-cols-md-2">
            <div className="col">
              <h5 className="mb-3">Descuentos</h5>
              <div className="row row-cols-md-2">
                <div className="col">
                  <label className="form-label">Otros Descuentos</label>
                  {dataTotalesGT.total_neto ? (
                    <input
                      className="form-control text-end"
                      type="text"
                      name="otros_descuentos_ep"
                      value={Math.round(Number(dataOtrosDescuentos)).toLocaleString('es-ES')}
                      onChange={(e) => {
                        const rawValue = e.target.value.replace(/\./g, ''); // Elimina puntos separadores
                        handleOtrosDescuentos(Number(rawValue), valorServicios);
                      }}
                    />
                  ) : (
                    <input
                      className="form-control text-end"
                      type="text"
                      name="otros_descuentos_ep"
                      value={0}
                      disabled
                    />
                  )}
                </div>
                <div className="col">
                  <label className="form-label">Detalle Descuentos</label>
                  <input
                    className="form-control"
                    type="text"
                    name="detalle_otros_descuentos_ep"
                    onChange={(e) => setEstadoPagoData({
                      ...dataEstadoPago,
                      ["detalle_otros_descuentos_ep"]: e.target.value
                    })}
                  />
                </div>
              </div>
            </div>
            <div className="col">
              <h5 className="mb-3">Valores Totales</h5>
              <div className="table-responsive border rounded">
                <table className="table table-sm mb-0">
                  <thead>
                    <tr className="table-active border-bottom">
                      <th scope="col">Total Neto</th>
                      <th scope="col">IVA</th>
                      <th scope="col" className="text-dark fw-semibold">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {valorServicios ? (
                      <tr>
                        <td className="text-end">$ {dataTotalesGT.total_neto.toLocaleString('es-ES')}</td>
                        <td className="text-end">$ {dataTotalesGT.iva.toLocaleString('es-ES')}</td>
                        <td className="text-end">$ <span className="text-orange">{dataTotalesGT.total.toLocaleString('es-ES')}</span></td>
                      </tr>
                    ) : (
                      <tr>
                        <td className="text-end">$ 0</td>
                        <td className="text-end">$ 0</td>
                        <td className="text-end">$ <span className="text-orange">0</span></td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-yellow" onClick={handleSubmitEstadoPagoGT}><i className="bi bi-floppy"></i> Guardar</button>
        </div>
      </div>
    </div>
  );
}